import Index from '@components/LocalMerchant/PotentialCustomers'
import Home from '@components/LocalMerchant/PotentialCustomers/Home'
import CreateBatchPush from '@components/LocalMerchant/PotentialCustomers/CreateBatchPush'
import PushDetail from '@components/LocalMerchant/PotentialCustomers/PushDetail'
import Introduce from '@components/LocalMerchant/PotentialCustomers/Introduce'
import ActivityPage from '@components/ActivityPage/PotentialCustomers'

export default [
  {
    path: 'potentialCustomers',
    component: Index,
    indexRoute: {
      component: Home
    },
    stat: '潜在客资转化/首页',
    childRoutes: [
      {
        path: 'createPush',
        component: CreateBatchPush,
        stat: '潜在客资转化/新建推送'
      },
      {
        path: 'pushDetail/:id',
        component: PushDetail,
        stat: '潜在客资转化/推送详情'
      },
      {
        path: 'introduce',
        component: Introduce,
        stat: '潜在客资转化/使用说明'
      }
    ]
  },
  {
    path: 'potentialCustomersIntro',
    component: ActivityPage,
    stat: '潜在客资转化/宣传页'
  }
]
